import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Step } from '../stepper/step';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'stepper-new',
	template: require('./stepper-new.component.html'),
})
export class StepperNewComponent {
	@Input()
	public transactionSteps: Step[];
	@Output()
	public emitStep: EventEmitter<number> = new EventEmitter<number>();

	public isExpanded: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	public emitSteps(i: number) {
		this.emitStep.emit(i);
	}

	constructor() {}

	public findStep(): number {
		let i = 0;
		while (i < this.transactionSteps.length) {
			if (this.transactionSteps[i].isActive) {
				i++;
			} else {
				return i;
			}
		}
		return i;
	}

	public expander(): void {
		this.isExpanded = !this.isExpanded;
	}
	public isCurrentStep(index: number) {
		if (this.transactionSteps[index].isActive) {
			return true;
		}
		return (
			(index + 1 === this.transactionSteps.length ||
				!this.transactionSteps[index + 1].isActive) &&
			this.transactionSteps[index].isActive
		);
	}
	public findActive(i: number) {
		if (i !== this.transactionSteps.length - 1) {
			return this.transactionSteps[i + 1].isActive;
		} else {
			return false;
		}
	}
}
